import { render, staticRenderFns } from "./knowInfo.vue?vue&type=template&id=2ba51130&"
import script from "./knowInfo.vue?vue&type=script&lang=js&"
export * from "./knowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports